import * as React from 'react';
import { useState } from 'react';
import _ from 'lodash';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';
import Autocomplete from '@mui/material/Autocomplete';

import { SpanError } from '../../components/customStyles/form';
import SimpleDatePicker from '../../components/date/SimpleDatePicker';

import { CLIENT_WORK_DATA, CLIENT_VALIDATE_RULE } from './constants';


const CreateClientWorkModal = (props) => {
  const {
    editMode,
    isLoading,
    inputErrorMsg,
    modalData,
    handleModalSubmit,
    handleClose
  } = props;

  const [workData, setWorkData] = useState(editMode ? modalData : CLIENT_WORK_DATA);


  const handleDateInput = (target, value) => {
    setWorkData(prev => ({
      ...prev,
      [target]: value
    }))
  }

  return (
    <Box
      sx={{
        width: { sx: '300px', md: '600px' },
        textAlign: 'start'
      }}
    >
      <Box mb={3}>
        <Box mb={1}>
          <Typography variant='h5'>客戶名稱<SpanError>*</SpanError></Typography>
        </Box>

        <Box>
          <Autocomplete
            id="client_select"
            options={ _.uniqBy(modalData, 'display_name')}
            autoHighlight
            getOptionLabel={(option) => option.display_name}
            renderOption={(props, option) => (
              <Box {...props}>{option.display_name}</Box>
            )}
            renderInput={(params) => (
              <TextField {...params} placeholder={'請選擇客戶'} />
            )}
            onChange={(event, newValue) => { handleDateInput("client_select", newValue) }}
          />
        </Box>
        <FormHelperText error={inputErrorMsg.client_select ? inputErrorMsg.client_select : false}>
          {inputErrorMsg.client_select ? CLIENT_VALIDATE_RULE.client_select.errorMsg : null}
        </FormHelperText>
      </Box>

      <Box mb={3}>
        <Box mb={1}>
          <Typography variant='h5'>資料開始日期<SpanError>*</SpanError></Typography>
        </Box>
        <SimpleDatePicker
          targetField="start_date"
          dateValue={workData.start_date}
          handleDateInput={handleDateInput}
          isError={inputErrorMsg.start_date ? inputErrorMsg.start_date : false}
          errorMsg={CLIENT_VALIDATE_RULE.start_date.errorMsg}
        />
      </Box>

      <Box mb={3}>
        <Box mb={1}>
          <Typography variant='h5'>資料結束日期<SpanError>*</SpanError></Typography>
        </Box>
        <SimpleDatePicker
          targetField="end_date"
          dateValue={workData.end_date}
          handleDateInput={handleDateInput}
          isError={inputErrorMsg.end_date ? inputErrorMsg.end_date : false}
          errorMsg={CLIENT_VALIDATE_RULE.end_date.errorMsg}
        />
      </Box>

      <FormHelperText error={inputErrorMsg.check_date ? inputErrorMsg.check_date : false}>{inputErrorMsg.check_date ? CLIENT_VALIDATE_RULE.start_date.errorMsg_check : null}</FormHelperText>

      <Stack
        variant='center-center'
        sx={{ margin: '32px 0 16px 0' }}
      >
        <>
          <Button
            variant="text-cancel"
            disabled={isLoading}
            onClick={handleClose}
          >
            取消
          </Button>

          <Button
            variant="fill-main"
            disabled={isLoading}
            endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
            onClick={() => handleModalSubmit(workData, 'creatWork')}
            sx={{ color: "#fff" }}
          >
            建立
          </Button>
        </>
      </Stack>
    </Box>
  )
}

export default CreateClientWorkModal;